import { LitElement, html, css } from 'lit';
import moment from 'moment-timezone';

import { navigate } from '../../../../../src/store';
import { createOnlineBookingAccountV2 } from '../../../../neb-api-client/src/permissions-api-client';
import {
  openError,
  openSuccess,
} from '../../../../neb-dialog/neb-banner-state';
import { store } from '../../../../neb-redux/neb-redux-store';
import { baseStyles } from '../../../../neb-styles/neb-styles';

import { NebFormCreateAccount } from './neb-form-create-account';

export const ELEMENTS = {
  form: { id: 'form' },
};

export const TEXT_TEMP_PASSWORD_SENT_EMAIL = 'Temporary password email sent!';
export const TEXT_UNABLE_TO_CREATE_USER =
  'There was a problem creating your account. Please check the email address provided or login with an existing account.';

class NebPageCreateAccount extends LitElement {
  static get properties() {
    return {
      __formModel: Object,

      layout: {
        type: String,
        reflect: true,
      },
      scheduling: {
        type: Boolean,
        reflect: true,
      },
      bookingAccountInviteId: String,
      redirectTo: String,
      emailFromInvite: String,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: block;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__formModel = NebFormCreateAccount.createModel();

    this.layout = '';
    this.scheduling = false;
    this.bookingAccountInviteId = '';
    this.redirectTo = '';
    this.emailFromInvite = '';
  }

  __initHandlers() {
    this.__handlers = {
      save: async data => {
        try {
          await this.__createOnlineBookingAccount(data);
          this.__navigateToLogin();
          store.dispatch(openSuccess(TEXT_TEMP_PASSWORD_SENT_EMAIL));
          this.__formModel = data;
        } catch (e) {
          store.dispatch(openError(TEXT_UNABLE_TO_CREATE_USER));
          this.__formModel = data;
        }
      },
    };
  }

  __createOnlineBookingAccount(data) {
    const { phone, birthdate, ...params } = data;
    const body = {
      ...params,
      birthdate: moment(birthdate).format('YYYY-MM-DD'),
      phoneNumber: phone.number,
      phoneType: phone.type,
      ...(this.bookingAccountInviteId
        ? { bookingAccountInviteId: this.bookingAccountInviteId }
        : {}),
    };

    return createOnlineBookingAccountV2(body);
  }

  __navigateToLogin() {
    if (this.scheduling) {
      return navigate('#/book-appointment/schedule/login');
    }

    const url = '#/login';

    if (this.bookingAccountInviteId) {
      const params = new URLSearchParams({
        bookingAccountInviteId: this.bookingAccountInviteId,
        ...(this.redirectTo ? { redirectTo: this.redirectTo } : {}),
        redirectFrom: 'create-account',
      });

      return navigate(`${url}?${params.toString()}`);
    }

    return navigate(url);
  }

  render() {
    return html`
      <neb-form-create-account
        id="${ELEMENTS.form.id}"
        .model="${this.__formModel}"
        .layout="${this.layout}"
        .onSave="${this.__handlers.save}"
        .emailFromInvite="${this.emailFromInvite}"
      ></neb-form-create-account>
    `;
  }
}

customElements.define('neb-page-create-account', NebPageCreateAccount);
